import { state } from "State";
import render from "Utils/template_render";

import * as SQL_QUERIES from "Services/sqlQueries";
import computeSqlParams from "Services/sqlQueryParams";
const domainState = state.select("domain_data");
import config from "Config";

/*
 * General Configuration of the SQL API
 * */
const sql_config = {
  sql_api_template: "https://louse.geodb.host:443/user/{user}",
  user: config.cartodb_username, // Required
  format: "json"
};

/*
 * params for the queries, basically api_key
 * */
const query_params = {
  // api_key: "1b92bcebb285b3f2dd27855cb4516951fe91f085"
};

export default (() => {
  let _sqlCache = {};
  let _paramsCache = {};
  let _domainData;

  const refreshDomainData = () => {
    _domainData = domainState.get();
    let key = JSON.stringify(_domainData);
    if (!_sqlCache[key]) {
      _sqlCache[key] = {};
    }
    if (!_paramsCache[key]) {
      _paramsCache[key] = computeSqlParams(_domainData);
    }
  };
  refreshDomainData();
  domainState.on("update", () => refreshDomainData());

  return {
    getData(
      queries,
      config = {},
      domainData = _domainData,
      pipeline = res => res
    ) {
      if (queries.constructor === Array) {
        let key = JSON.stringify(domainData);
        let name = JSON.stringify(queries);
        !_sqlCache[key] && (_sqlCache[key] = {});
        if (_sqlCache[key][name]) {
          return new Promise((resolve, reject) =>
            resolve(_sqlCache[key][name])
          );
        } else {
          return Promise.all(
            queries.map(
              (query, i) =>
                new Promise((resolve, reject) =>
                  (cartodb.hasOwnProperty("SQL")
                    ? cartodb.SQL(sql_config)
                    : cartodb
                  ).chain(sql =>
                    sql
                      .execute(
                        this.getQuery(query, domainData),
                        {},
                        { ...query_params, ...config }
                      )
                      .done(resolve)
                      .error(e => {
                        console.log(e);
                        throw {
                          ERROR: "ERROR: getData: query failed",
                          error: e,
                          query_var: query,
                          query_number: i,
                          computedParams: computeSqlParams(domainData),
                          domainData: domainData,
                          query: this.getQuery(query, domainData),
                          all_queries: queries,
                        }.log("error");
                      })
                  )
                )
            )
          ).then(
            res =>
              (_sqlCache[key][name] = pipeline(res)) && _sqlCache[key][name]
          );
          // .catch(err => console.log(JSON.stringify(err)));
        }
      } else {
        return this._getData(queries, config, domainData, pipeline);
      }
    },

    /*
     * use the cartodb library to do an sql query
     * returns a Promise that resolves to the result
     * (which will be cached for later requests)
     * */
    _getData(
      NAME,
      config = {},
      domainData = _domainData,
      pipeline = res => res
    ) {
      return new Promise((resolve, reject) => {
        let key = JSON.stringify(domainData);
        !_sqlCache[key] && (_sqlCache[key] = {});
        if (_sqlCache[key][NAME]) {
          resolve(_sqlCache[key][NAME]);
        } else {
          cartodb
            .SQL(sql_config)
            .execute(
              this.getQuery(NAME, domainData),
              {},
              { ...query_params, ...config }
              //              cartodb.SQL(sql_config).execute(
              //                SQL_QUERIES[NAME], _paramsCache[key], {...query_params,  ...config})
            )
            .done(res => (_sqlCache[key][NAME] = pipeline(res)).chain(resolve))
            .error(e => {
              throw {
                ERROR: "ERROR: _getData: query failed",
                error: e,
                query_var: NAME,
                computedParams: computeSqlParams(domainData),
                domainData: domainData,
                query: this.getQuery(NAME, domainData)
              };
            });
        }
      });
    },

    /*
     * returnes the query for the given name, substituting the
     * params with the current domain_data or the values from
     * then params argument if provided, for manual execution
     * against cartos sql api after running it through the 
     * computeSqlParams(domainData) function
     *       */
    getQuery(NAME, domainData = _domainData) {
      let key = JSON.stringify(domainData);
      _paramsCache[key] || (_paramsCache[key] = computeSqlParams(domainData));
      let params = _paramsCache[key];
      let query = SQL_QUERIES[NAME];
      // [params, query].log("getQuery: [params,query]")
      if (!query) console.log("not defined: " + NAME);
      return render(query, params); //.log("Final query");
    }
  };
})();



// WEBPACK FOOTER //
// ./services/databaseCache.js